import { createChildListPrintContainer } from 'factories/ChildListPrint'
import actions from 'actions/rfqs/rfqSuppliers'
import Component from 'components/Rfqs/Print/Suppliers'

export default createChildListPrintContainer({
  actions,
  extraStateToProps: (state, props) => ({ settingsType: props.settingsType ?? 'rfq' }),
})(Component)
